import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3152, { U3152ROLES } from './U3152';
import U3152ContactTypeList from './components/U3152ContactTypeList';
import U3152ContactTypeForm from './components/U3152ContactTypeForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3152Routes: RouteObject[] = [
  {
    path: 'U3152',
    element: <U2000RequireRole allowedRoles={[U3152ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3152 />,
        children: [
          { index: true, element: <U3152ContactTypeList /> },
          { path: ':id', element: <U3152ContactTypeForm /> },
        ],
      },
    ],
  },
];

export default U3152Routes;
